import { render, staticRenderFns } from "./DefaultFlowNode.vue?vue&type=template&id=f1330de0&scoped=true&"
import script from "./DefaultFlowNode.vue?vue&type=script&lang=js&"
export * from "./DefaultFlowNode.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFlowNode.vue?vue&type=style&index=0&id=f1330de0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1330de0",
  null
  
)

export default component.exports